import { UserInvite } from '@/components/UserInvite/UserInvite';
import { useGet } from '@/query/fetchHooks';
import { useTranslation } from 'react-i18next';
import { IconButton, PersonAvatar, Button, TeamAvatar } from '@teo/components';
import { CrossFilled, ChevronDownFilled } from '@teo/components/icons';
import { useState, useEffect, Fragment } from 'react';
import PaginationNew from '@/components/DataTable/PaginationNew';
import { Listbox, Transition } from '@headlessui/react';
import { clsx } from 'clsx';

const EvaluatorsTab = ({
  authUser,
  value,
  handleAddTeacherToList,
  handleRemoveTeacher,
  setTeachers,
  teachers,
  newTeachers,
  currentTeachers,
  setCurrentTeachers,
  setDelTeachers,
}: any) => {
  const { t } = useTranslation();

  const [count, setCount] = useState(10);
  const [maxPage, setMaxPage] = useState(1);
  const [offset, setOffset] = useState(0);

  const [showList, setShowList] = useState([]);

  const showOptions = [
    {
      value: 10,
      label: '10',
    },
    {
      value: 20,
      label: '20',
    },
    {
      value: 40,
      label: '40',
    },
    {
      value: 80,
      label: '80',
    },
  ];

  const [showType, setShowType] = useState(showOptions[0]);

  useEffect(() => {
    if (currentTeachers) {
      const contentRange = currentTeachers?.length;
      const maxCount = contentRange ? contentRange : 1;
      setMaxPage(Math.ceil(maxCount / count));
    }
  }, [currentTeachers, showType]);

  const page = Math.floor(offset / count) + 1;

  const chunkArray = (array: [], count: number) => {
    const result = [];

    for (let i = 0; i < array.length; i += count) {
      result.push(array.slice(i, i + count));
    }

    return result;
  };

  useEffect(() => {
    const newList = chunkArray(currentTeachers, count);
    setShowList(newList[page - 1]);
  }, [offset, currentTeachers, showType]);

  const handleDeleteUsr = (usr: any) => {
    setCurrentTeachers((prev: any) =>
      prev?.filter((el: any) => el?.userId != usr?.userId)
    );
    setDelTeachers((prev: any) => [...prev, usr]);
  };
  return (
    <>
      <div id="invite_teacher" className="ali relative z-[11] flex w-full">
        <span className="w-full">
          <UserInvite
            fetch={useGet.bind(null, '/memberdetails', {
              organisationId: authUser?.activeOrganisationId,
              minrole: 70,
            })}
            //multiselectLabel={t('pages.create_edit_course.multiselect_label')}
            inviteButtonText={t('pages.manage_add_users.add_button')}
            value={teachers}
            onChange={setTeachers}
            handleAddUserToList={handleAddTeacherToList}
            addValue={(email: string) => {
              const newValue = [
                ...value,
                {
                  email: email,
                  label: email,
                  key: email,
                  id: email,
                  userId: email,
                  newUser: true,
                },
              ];
              setTeachers(newValue);
              return newValue;
            }}
          />
        </span>
      </div>
      <div>
        {newTeachers.map((item: any) => (
          <div
            key={item.userId !== null ? item.key : item.teamId}
            className="mb-4 flex items-center justify-between"
          >
            <div className="flex items-center">
              <TeamAvatar
                id={item?.id}
                name={item?.label}
                bgColor={item?.color}
              />
              <div className="flex flex-col pl-4">
                <span className="text-sm font-medium text-[#231f20]">
                  {item.label}
                </span>
              </div>
            </div>
            <div data-testid="daleteItem" className="my-auto mx-6">
              <IconButton
                Icon={CrossFilled}
                variant="ghost"
                onClick={() => handleRemoveTeacher(item.key)}
              />
            </div>
          </div>
        ))}
      </div>
      {currentTeachers?.length > 0 && (
        <div className="mt-6 flex flex-col gap-2">
          <h3 className="mb-4 text-base">
            {t('pages.course_content_flow.step_1.already_added')}
          </h3>
          {showList?.map((user: any) => {
            return (
              <div
                key={user?.userId}
                className="flex flex-row items-center gap-2 py-1"
              >
                <div className="flex items-center">
                  <PersonAvatar
                    inline
                    id={user.id}
                    name={user.username || ''}
                    imageSrc={user.picture || undefined}
                  ></PersonAvatar>
                  <div>
                    <div
                      className={`overflow-hidden text-ellipsis text-sm font-medium `}
                    >
                      {user.username}
                    </div>
                  </div>
                </div>

                <div className="ml-auto">
                  <Button
                    variant="ghost"
                    className="!px-2"
                    onClick={() => handleDeleteUsr(user)}
                  >
                    <CrossFilled className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            );
          })}

          {maxPage > 1 && (
            <div className="flex w-full items-center justify-between">
              <div>
                <PaginationNew
                  setOffset={setOffset}
                  offset={offset}
                  count={count}
                  page={page}
                  maxPage={maxPage}
                />
              </div>
              <div className="flex items-center">
                <div className="ml-2 flex items-center gap-1">
                  <p className="mr-1 text-sm text-grey-07">
                    {t('pagination.show')}
                  </p>
                  <div>
                    <Listbox
                      value={showType}
                      onChange={(newShowType) => {
                        setShowType(newShowType);
                        setCount(newShowType?.value);
                        setOffset(
                          Math.floor(offset / newShowType?.value) *
                            newShowType?.value
                        );
                      }}
                    >
                      {({ open }) => (
                        <div>
                          <Listbox.Button
                            className={clsx(
                              'flex items-center justify-between',
                              'rounded-md border border-solid outline outline-2',
                              'min-h-10 w-full min-w-[70px] px-2 text-base',
                              {
                                'border-secondary-04 bg-white outline-secondary-01':
                                  open,
                                'border-transparent bg-grey-transparent-01 text-grey-08 outline-transparent hover:border-grey-transparent-03 hover:bg-white hover:outline-grey-transparent-01 focus:border-secondary-04 focus:bg-white focus:outline-secondary-01':
                                  !open,
                              }
                            )}
                          >
                            <span className="mr-2 block truncate">
                              {!showType?.label ? '' : showType?.label}
                            </span>
                            <ChevronDownFilled
                              className={clsx(
                                'h-5 w-5',
                                'transition-transform',
                                open && 'rotate-180'
                              )}
                            />
                          </Listbox.Button>
                          <Transition
                            as={Fragment}
                            leave="transition-opacity"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <div className="listbox relative z-10">
                              <Listbox.Options className="absolute bottom-0 mt-1  flex max-h-40 w-full -translate-y-[42px] cursor-pointer flex-col gap-1 overflow-auto rounded-lg bg-white p-1 drop-shadow-s focus:outline-none">
                                {showOptions.map((option, optionIndex) => (
                                  <Listbox.Option
                                    key={optionIndex}
                                    className={({ active }) =>
                                      clsx(
                                        'rounded-md px-3 py-2 text-base text-black',
                                        active && 'bg-grey-transparent-02'
                                      )
                                    }
                                    value={option}
                                  >
                                    {({ selected }) => (
                                      <span
                                        className={clsx(
                                          'block',
                                          selected && 'font-medium'
                                        )}
                                      >
                                        <span>{option?.label}</span>
                                      </span>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </div>
                          </Transition>
                        </div>
                      )}
                    </Listbox>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default EvaluatorsTab;
